import { ROLES } from 'constants/userConstants';

export const employeeRequiredFields = ['firstName', 'lastName', 'email', 'status', 'occupationStatus', 'projectNames', 'profilePictureImgUrl', 'experience', 'projectEndDate', 'employmentType', 'position', 'clients', 'employeeType'];
export const employeeRoles = [ROLES.ADMIN, ROLES.EMPLOYEE];
export const teamRoles = [ROLES.ADMIN, ROLES.EMPLOYEE, ROLES.SUPPLIER_ADMIN, ROLES.SUPPLIER_EMPLOYEE];
